import { format, utcToZonedTime } from "date-fns-tz";

// Inspired by: https://stackoverflow.com/a/63227335
export const formatInTimeZone = (date, fmt, tz) => format(utcToZonedTime(date, tz), fmt, { timeZone: tz });
